import { createFileRoute } from '@tanstack/react-router';
import { ProductForm } from '@/pages/products/form/product-form';
import { PROTECTED, REGISTRY } from '@/lib/constants/routes';

export const Route = createFileRoute(
  '/protected/_layout/registry/_layout/products/new'
)({
  component: () => <ProductForm returnUrl={`${PROTECTED}${REGISTRY}`} />,
});
